import css from 'styled-jsx/css';

const articlesCSS = css`
  section.container {
    margin-bottom: 35px;
    padding: 0;
    overflow: auto;
  }

  .articles-container {
    overflow: hidden;
  }

  .articles-title {
    margin: 0 0 15px 0;
  }

  .row {
    margin: 0;
  }
`;

export default articlesCSS;
